import { dayjs } from '../../utils/dayjs';

export const ENDPOINT_DATE_FORMAT = 'YYYY-MM-DD';

const splitDateRangeByMonth = ([start, end]) => {
  const startDt = dayjs(start, ENDPOINT_DATE_FORMAT);
  const endDt = dayjs(end, ENDPOINT_DATE_FORMAT);

  const originalRangeDates = { start: startDt, end: endDt };

  const fullMonthsToFill = [];
  for (
    let dt = startDt.add(1, 'month').startOf('month');
    dt.isBefore(endDt.startOf('month'));
    dt = dt.add(1, 'month').startOf('month')
  ) {
    fullMonthsToFill.push(dt.startOf('month'));
  }

  if (fullMonthsToFill.length < 1 && startDt.isSame(endDt, 'month')) {
    return [
      {
        originalRangeDates,
        monthStart: startDt.startOf('month').format(ENDPOINT_DATE_FORMAT),
        startDay: startDt.date(),
        endDay: endDt.date(),
      },
    ];
  }

  return [
    {
      originalRangeDates,
      monthStart: startDt.startOf('month').format(ENDPOINT_DATE_FORMAT),
      startDay: startDt.date(),
      endDay: startDt.endOf('month').date(),
    },
    ...fullMonthsToFill.map((dt) => ({
      originalRangeDates,
      monthStart: dt.startOf('month').format(ENDPOINT_DATE_FORMAT),
      startDay: 1,
      endDay: dt.endOf('month').date(),
    })),
    {
      originalRangeDates,
      monthStart: endDt.startOf('month').format(ENDPOINT_DATE_FORMAT),
      startDay: 1,
      endDay: endDt.date(),
    },
  ];
};
export const splitDateRangesByMonth = (dateRanges) => {
  const res = dateRanges
    .flatMap((r) => splitDateRangeByMonth(r))
    .reduce(
      (acc, evt) => ({
        ...acc,
        [evt.monthStart]: [...(acc[evt.monthStart] || []), evt],
      }),
      {}
    );

  return res;
};

export function getMonthStartDateString(ts) {
  return dayjs.unix(ts).set('date', 1).format('YYYY-MM-DD');
}

export function getCurrentMonthStartDateString() {
  return getMonthStartDateString(new Date().getTime() / 1000);
}
